"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaffleService = void 0;
const games_1 = require("../models/games");
const api_1 = require("./api");
const PATH = '/raffle/api/v1';
const PATH_GAME = 'game/api';
class RaffleService {
    static async getRaffleGames() {
        const url = `${PATH_GAME}/published-games?gameTypeId.in=7&page=0`;
        try {
            const response = await api_1.API.get({ url });
            const parsedGames = games_1.Game.JsonToGames(response.content);
            return parsedGames;
        }
        catch (error) {
            return error;
        }
    }
    static async getWinningNumbers(gameId, startDate, tickets) {
        const url = `${PATH}/winning-results`;
        try {
            const response = await api_1.API.post({
                url,
                body: {
                    gameId,
                    startDate,
                    tickets
                }
            });
            return response;
        }
        catch (error) {
            return error;
        }
    }
}
exports.RaffleService = RaffleService;
//# sourceMappingURL=raffle-service.js.map